<template>
  <div>
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="所属单位：" prop="unitId">
          <el-select
            size="mini"
            v-model="form.unitId"
            filterable
            placeholder="请选择所属单位"
            clearable
            reserve-keyword
            :remote="true"
            @change="chooseUnit"
            :remote-method="searchUnitList"
            @visible-change="searchUnitList('')"
          >
            <el-option
              v-for="item in unitList"
              :key="item.id"
              :label="item.unitName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门：" prop="departmentId" class="mr0">
          <el-select
            size="mini"
            v-model="form.departmentId"
            filterable
            placeholder="请选择所属部门"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchDepartmentList"
            @visible-change="searchDepartmentList('')"
          >
            <el-option
              v-for="item in departmentList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登陆账号：" prop="phone">
          <el-input size="mini" v-model.trim="form.phone" placeholder="请输入手机号或登陆号" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码：" class="mr0" prop="password">
          <el-input size="mini" v-model.trim="form.password" placeholder="请输入密码" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="nickname">
          <el-input size="mini" v-model.trim="form.nickname" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别：" class="mr0">
          <el-select size="mini" v-model="form.sex" value-key="dictionaryCode">
            <el-option
              v-for="item in control"
              :key="item.dictionaryCode"
              :label="item.dictionaryValue"
              :value="item.dictionaryCode"
              placeholder="请选择性别"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否部门管理：" label-width="98px" class="label-with-six-word">
          <el-select size="mini" v-model="form.departmentManage" value-key="dictionaryCode">
            <el-option
              v-for="item in control"
              :key="item.dictionaryCode"
              :label="item.dictionaryValue"
              :value="item.dictionaryCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权应用：" class="checkbox-group-box mr0">
          <el-checkbox-group v-model="checkList">
            <el-checkbox @change="changeCheck(item)" v-for="item in appTypeList" :key="item.typeCode" :label="item.typeCode">{{item.typeName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="授权角色：" class="checkbox-group-box mr0">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="item.appName" :name="item.appCode" v-for="item in roleSimpleList" :key="item.appCode">
							<el-checkbox-group v-model="checkList">
								<el-checkbox @change="changeCheck(it)" v-for="it in item.roleList" :key="it.roleCode" :label="it.roleCode">{{it.roleName}}</el-checkbox>
							</el-checkbox-group> 
						</el-tab-pane>
          </el-tabs>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getAppTypeList, getRoleSimpleList, getUnitSimpleList, getDepartmentSimpleList } from '@/api/UserManagement'
export default {
  data() {
    return {
      control: [
        { dictionaryValue: "是", dictionaryCode: 1 },
        { dictionaryValue: "否", dictionaryCode: 0 },
      ],
      form: {
        unitId: '',
        departmentId: '',
        nickname: '',
        password: '',
        sex: '',
        phone: '',
        departmentManage: '',
        liftIdList: [],
        applicationRoleList: {}

      },
      rules: {
        unitId: [
          {
            required: true,
            message: "请选择所属单位",
            trigger: "change",
          }
        ],
        departmentId: [
          {
            required: true,
            message: "请选择所属部门",
            trigger: "change",
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号或登陆账号",
            trigger: "blur",
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        dorder: [
          {
            required: true,
            message: "请输入排序号",
            trigger: "blur",
          },
        ],
      },
      resourceTypeList: [],
			checkList: [],
      activeName: 'YHGHT',
      appTypeList: [],
      unitList: [],
      departmentList: [],
      appTypeCodeList: [],
      roleSimpleList: []
      
    };
  },
  created() {
    // this.searchUnitList()
    // this.searchDepartmentList()
  },
  methods: {
    async searchUnitList(keyword) {
		  const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100
      })
      if (res.code === 200) {
        this.unitList = res.data
      }
    },
    async searchDepartmentList(keyword) {
      if (!this.form.unitId) {
        this.departmentList = []
        return
      }
      const res = await getDepartmentSimpleList({
        keyword: keyword,
        size: 100,
        unitId: this.form.unitId
      })
      if (res.code === 200) {
        this.departmentList = res.data
      }
    },
    async getRoleSimpleList() {
      const res = await getRoleSimpleList({appCodeList: this.appTypeCodeList})
      if (res.code === 200){
        this.roleSimpleList = res.data
      }
      
    },
    async getAppTypeList() {
      const res = await getAppTypeList({unitId: this.form.unitId})
      if (res.code === 200) {
        this.appTypeList = res.data
        this.appTypeCodeList = res.data.map(item => item.typeCode)
        this.getRoleSimpleList()
      }
    },
    async getResourceTypeList() {
      const res = await getResourceTypeList();
      if (res.code === 200) {
        this.resourceTypeList = res.data;
      }
    },
    chooseResourceType(value) {
      if (value == 3 || value == 4) {
        this.form.menuShow = 0;
      } else {
        this.form.menuShow = 1;
      }
		},
		handleClick(tab) {

    },
    changeCheck(item) {
      console.log(this.checkList)
    },
    chooseUnit(val) {
      if (val) {
        this.getAppTypeList()
      }
      
    }
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/UserManagement/components/PeopleInfo.vue